// extracted by mini-css-extract-plugin
module.exports =  {"selector":"selector-uRGQ6","next":"next-t6hvT","prev":"prev-__2gh","icon":"icon-ixEYr","label":"label-xSEWG","selected":"selected-lBBwk","year":"year-jHuog","month":"month-VlFJ6"};